export default {
      id: "list-usage",
      viewBox: "0 0 16 12",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#list",
      toString: function () {
        return this.url;
      }
    }